<template>
  <div class="marquee-component">
    <div ref="notice" class="notice" :style="style">{{ notice }}</div>
  </div>
</template>

<script>

const speed = 10
export default {
  name: 'Marquee',
  props: {
    notices: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      boxWidth: '300%',
      width: 500,
      index: 0,
      style: ''
    }
  },
  computed: {
    notice() {
      return this.notices[this.index] || '通知'
    }
  },
  watch: {
    notices() {
      this.index = 0
      clearTimeout(this.timer)
    },
    notice() {
      this.start()
    }
  },
  mounted() {
    this.boxWidth = this.$el.getBoundingClientRect().width + 'px'
    this.start()
  },

  methods: {
    start() {
      this.style = {
        paddingLeft: this.boxWidth
      }
      this.$nextTick(() => {
        this.width = this.$refs.notice.scrollWidth
        this.style = {
          paddingLeft: this.boxWidth,
          transition: `transform ${this.width * speed}ms linear`,
          transform: `translateX(-${this.width}px)`
        }
        this.timer = setTimeout(() => {
          if (!this.notices.length || (this.notices.length === 1)) {
            this.start()
            return
          }
          this.index = (this.index + 1) % this.notices.length
        }, this.width * speed + 100)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.marquee-component {
  overflow-x: hidden;
  .item {
    display: inline-block;
    word-break: keep-all;
  }
  .notice {
    text-align: left;
    // box-sizing: border-box;
    // animation: 5s linear infinite notices;
    word-break: keep-all;
    min-width: 100%;
    white-space: nowrap;
  }
}

</style>
